import * as React from "react";
import { useMemo } from "react";
import useDefaultInterval from "views/hooks/useDefaultIntervalForRefresh";
import { durationToMS } from "util/DateTime";
import AutoRefreshProvider from "views/components/contexts/AutoRefreshProvider";
import Spinner from "../common/Spinner";
const noop = () => {
};
const EventsRefreshProvider = ({ children = void 0 }) => {
  const defaultInterval = useDefaultInterval();
  const defaultRefreshConfig = useMemo(
    () => ({ enabled: false, interval: durationToMS(defaultInterval) }),
    [defaultInterval]
  );
  return defaultInterval === null ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(AutoRefreshProvider, { onRefresh: noop, defaultRefreshConfig }, children);
};
export default EventsRefreshProvider;
